import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { Button } from 'reactstrap'
import { Link, useNavigate } from 'react-router-dom'
import { deletePricingTable, getAllPricingTable, getAllService } from '../../redux/slices/pricingTableSlice'
import FeatherIcon from 'feather-icons-react'
import { Table } from 'antd'
import Pagination from '../../component/common/pagination'
import DeletePopup from '../../component/deletePopup'
import { errorToast, successToast } from '../../util/Toast/toast'
import { SpinnerContext } from '../../context/spinnerContext'
import { formatAmount } from '../../helper/function'
import { getUserRole, hasAccess } from '../../helper/function'

const PricingTable = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { allRegion } = useSelector(({ region }) => region)
  const { allPricingTable, allService } = useSelector(({ pricingTable }) => pricingTable)

  const [isRefresh, setIsRefresh] = useState(false)
  const [pricingID, setPricingID] = useState(null)
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [selectedService, setSelectedService] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [loader, setLoader] = useState(false)

  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1) // Add 1 to the index to start from 1
  }

  const handleEdit = (pricing_table_id) => {
    navigate(`/pricing/edit/${pricing_table_id}`)
  }

  const onDelete = () => {
    setIsRefresh(false)
    if (pricingID) {
      changeLoader(true)
      dispatch(deletePricingTable(pricingID)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  // Fetch regions and Service
  useEffect(() => {
    const fetchRegionsAndService = async () => {
      try {
        await Promise.all([dispatch(getAllRegion()), dispatch(getAllService({ is_pagination: false }))])
      } catch (err) {
        console.error('Error fetching regions and Service:', err)
      }
    }
    fetchRegionsAndService()
  }, [])

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: itemsPerPage || 10,
      sort_column: 'created_at',
      sort_order: 'DESC',
      region_id: selectedRegion,
      service_id: selectedService
    }
    changeLoader(true)
    setLoader(true)
    dispatch(getAllPricingTable(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
          setLoader(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
          setIsRefresh(false)
          setLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }, [currentPage, itemsPerPage, selectedRegion, isRefresh, selectedService])

  const handleSelectRegion = (region_id) => setSelectedRegion(region_id)
  const handleSelectService = (serviceId) => setSelectedService(serviceId)

  const columns = [
    {
      title: 'Bedrooms',
      dataIndex: 'bedroom',
      key: 'bedroom',
      render: (text) => parseFloat(text) // Ensure single decimal point format
    },
    {
      title: 'Bathrooms',
      dataIndex: 'bathroom',
      key: 'bathroom',
      render: (text) => parseFloat(text)
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (text) => `${formatAmount(text) || 0}`
    },
    {
      title: 'Exceed Price',
      dataIndex: 'exceed_price',
      key: 'exceed_price',
      render: (text) => `${formatAmount(text) || 0}`
    },
    {
      title: 'Average Time',
      dataIndex: 'avg_time',
      key: 'avg_time',
      render: (text) => `${parseFloat(text).toFixed(1)}h`
    },
    {
      title: 'Payout',
      dataIndex: 'cleaner_payout',
      key: 'cleaner_payout',
      render: (text) => `${parseFloat(text).toFixed(1)}%` // Ensure single decimal point format
    }
  ]

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Pricing Table</h5>
          </div>
        </div>

        {/* Filters and New Table Button */}
        <div className="deshboard_topbar">
          <div className="schedule_sec dropdown_with_btn">
            <div className="regions_sec">
              <Dropdown>
                <Dropdown.Toggle className="dropdown_opction_one" id="dropdown-basic">
                  {selectedRegion ? allRegion?.find((region) => region.region_id === selectedRegion)?.region : 'Regions'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSelectRegion(null)}>All Regions</Dropdown.Item>
                  {allRegion?.map((region) => (
                    <Dropdown.Item key={region.region_id} onClick={() => handleSelectRegion(region?.region_id)}>
                      {region.region}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="regions_sec">
              <Dropdown>
                <Dropdown.Toggle className="dropdown_opction_one" id="dropdown-basic">
                  {selectedService ? allService?.find((prop) => prop.service_id === selectedService).service : 'Service'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSelectService(null)}>All Service</Dropdown.Item>
                  {allService?.map((service) => (
                    <Dropdown.Item key={service.service_id} onClick={() => handleSelectService(service?.service_id)}>
                      {service.service}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="regions_sec">
              {hasAccess('addEditDeletePricingTable', getUserRole()) && (
                <Button className="btn btn-primary btn-small circle_btn" onClick={() => navigate(`/pricing/new`)}>
                  New Table
                </Button>
              )}
            </div>
          </div>
        </div>

        {/* Pricing Table Display */}
        <div className="row">
          <div className="col-sm-12">
            {allPricingTable?.totalRecords > 0 ? (
              <div className="accordion_main_div">
                <Accordion>
                  {allPricingTable?.pricingData?.map((row, index) => (
                    <Accordion.Item eventKey={String(index)} key={row?.key}>
                      <Accordion.Header>
                        <div className="d-flex justify-content-between w-100 align-items-center">
                          <h6 className="fw-600" style={{ wordBreak: 'break-word', paddingRight: '10px' }}>
                            {row?.name}
                          </h6>
                          {hasAccess('addEditDeletePricingTable', getUserRole()) && (
                            <div className="d-flex align-items-center purchase">
                              <Link
                                className="btn-action-icon me-2 edit_icon_div"
                                onClick={(e) => {
                                  e.preventDefault()
                                  handleEdit(row?.pricing_table_id)
                                }}
                              >
                                <FeatherIcon icon="edit" style={{ width: '15px', height: '15px' }} />
                              </Link>

                              {!row?.is_default && (
                                <Link
                                  className="btn-action-icon delete_icon_div me-3"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    openDeleteModal()
                                    setPricingID(row?.pricing_table_id)
                                  }}
                                >
                                  <FeatherIcon icon="trash-2" style={{ width: '15px', height: '15px' }} />
                                </Link>
                              )}
                            </div>
                          )}
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="d-flex justify-content-between mb-3" style={{ color: '#515151', gap: '10px' }}>
                          <p className="fw-600">Region: {row?.region?.region}</p>
                        </div>
                        <div className="card-table">
                          <div className="card-body purchase">
                            <div className="table-responsive table-hover">
                              <Table
                                columns={columns}
                                dataSource={row?.pricing_table_detail || []} // Display a single row at a time in the table
                                pagination={false} // Disable pagination for each row
                                showHeader={true} // Show table header
                                rowKey="key"
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            ) : (
              !loader && <p style={{ textAlign: 'center' }}>No Data Found</p>
            )}
          </div>
        </div>

        {/* Pagination */}
        <div className="row">
          {allPricingTable?.totalRecords > 0 && (
            <Pagination
              currentPage={currentPage}
              onPageChange={handlePageChange}
              totalPages={allPricingTable?.totalPage || 0}
              itemsPerPage={itemsPerPage}
            />
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </div>
  )
}

export default PricingTable
